module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/result/banner-0fea7df6af8b3bc8ee5fca103f8c0162.png";